import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getMyPostings } from '../../services/applicationService';
import ApplicationsReceived from '../../components/applications/ApplicationsReceived';

// Hub: everything the member has posted + the applications/referrals received.
const MyPostings = () => {
  const { currentUser } = useAuth();
  const [data, setData] = useState({ jobs: [], projects: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!currentUser) return;
      setLoading(true);
      try {
        const res = await getMyPostings(currentUser.uid);
        if (!cancelled) setData(res);
      } catch (e) {
        console.error('Failed to load postings:', e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [currentUser]);

  const renderPosting = (p, type) => {
    const count = (p.applications || []).length;
    return (
      <div key={p.id} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
        <div className="flex items-center justify-between mb-3">
          <Link to={`/${type}s/${p.id}`} className="font-semibold text-gray-900 hover:text-apn-blue">
            {p.title || 'Untitled'}
          </Link>
          <span className="text-sm text-gray-500">{count} application{count === 1 ? '' : 's'}</span>
        </div>
        <ApplicationsReceived applications={p.applications || []} collapsible={true} />
      </div>
    );
  };

  if (loading) {
    return <div className="max-w-4xl mx-auto px-4 py-8 text-gray-500">Loading your postings…</div>;
  }

  const nothing = data.jobs.length === 0 && data.projects.length === 0;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-2">My Postings</h1>
      <p className="text-gray-600 mb-6">
        Jobs and projects you've posted, and the applications &amp; referrals you've received.
      </p>

      {nothing ? (
        <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
          <p className="text-gray-600 mb-4">You haven't posted any jobs or projects yet.</p>
          <div className="flex justify-center gap-3">
            <Link to="/jobs" className="bg-apn-blue text-white px-4 py-2 rounded-md hover:bg-apn-dark-blue">Browse / Post Jobs</Link>
            <Link to="/projects" className="border border-apn-blue text-apn-blue px-4 py-2 rounded-md hover:bg-gray-50">Browse / Post Projects</Link>
          </div>
        </div>
      ) : (
        <>
          {data.jobs.length > 0 && (
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">Your Jobs</h2>
              {data.jobs.map((j) => renderPosting(j, 'job'))}
            </section>
          )}
          {data.projects.length > 0 && (
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">Your Projects</h2>
              {data.projects.map((p) => renderPosting(p, 'project'))}
            </section>
          )}
        </>
      )}
    </div>
  );
};

export default MyPostings;
